const getClearedHouseNumber = houseNumber => {
  if (houseNumber === null || houseNumber === undefined) return houseNumber

  return ''
}

export const getShippingAddress = (shippingAddress, deliveryMethod, originalShippingAddress) => {
  const disableAutoComplete = deliveryMethod?.disable_address_autocomplete

  return {
    ...shippingAddress,
    line_1: disableAutoComplete ? '' : originalShippingAddress?.line_1,
    line_2: disableAutoComplete ? '' : originalShippingAddress?.line_2,
    house_number: disableAutoComplete
      ? getClearedHouseNumber(originalShippingAddress?.house_number)
      : originalShippingAddress?.house_number,
    first_name: disableAutoComplete ? '' : originalShippingAddress?.first_name,
    last_name: disableAutoComplete ? '' : originalShippingAddress?.last_name,
    postcode: disableAutoComplete ? '' : originalShippingAddress?.postcode,
    locality: disableAutoComplete ? '' : originalShippingAddress?.locality,
  }
}
